/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type { Jubjub, JubjubInterface } from "../../contracts/Jubjub";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_pollId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_pollAddr",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Jubjub.PubKey",
        name: "_pubKey",
        type: "tuple",
      },
    ],
    name: "DeployPoll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract ISignUpGatekeeper",
        name: "_signUpGatekeeper",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IInitialVoiceCreditProxy",
        name: "_topupCredit",
        type: "address",
      },
    ],
    name: "Init",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_pollId",
        type: "uint256",
      },
    ],
    name: "MergeMaciStateAq",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_pollId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_numSrQueueOps",
        type: "uint256",
      },
    ],
    name: "MergeMaciStateAqSubRoots",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_messageRoot",
        type: "uint256",
      },
    ],
    name: "MergeMessageAq",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_numSrQueueOps",
        type: "uint256",
      },
    ],
    name: "MergeMessageAqSubRoots",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "msgType",
            type: "uint256",
          },
          {
            internalType: "uint256[10]",
            name: "data",
            type: "uint256[10]",
          },
        ],
        indexed: false,
        internalType: "struct Jubjub.Message",
        name: "_message",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Jubjub.PubKey",
        name: "_encPubKey",
        type: "tuple",
      },
    ],
    name: "PublishMessage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_stateIndex",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Jubjub.PubKey",
        name: "_userPubKey",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_voiceCreditBalance",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "SignUp",
    type: "event",
  },
  {
    inputs: [],
    name: "blankMessageLeafHash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "blankStateLeafHash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "calculateCurrentMessageBatchIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "closeSignUpPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "coordinatorPubKey",
    outputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "coordinatorPubKeyHash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentBallotCommitment",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentMessageCommitment",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentSbCommitment",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentStateCommitment",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "debugCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_left",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_right",
        type: "uint256",
      },
    ],
    name: "hash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "msgType",
            type: "uint256",
          },
          {
            internalType: "uint256[10]",
            name: "data",
            type: "uint256[10]",
          },
        ],
        internalType: "struct Jubjub.Message",
        name: "_message",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey",
        name: "_encPubKey",
        type: "tuple",
      },
    ],
    name: "hashMessageLeaf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "x",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "y",
                type: "uint256",
              },
            ],
            internalType: "struct Jubjub.PubKey",
            name: "pubKey",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "voiceCreditBalance",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.StateLeaf",
        name: "_stateLeaf",
        type: "tuple",
      },
    ],
    name: "hashStateLeaf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stateTreeDepth",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_messageTreeDepth",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_stateTreeSubDepth",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_messageTreeSubDepth",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "_emptyBallotRoots",
        type: "uint256[]",
      },
      {
        internalType: "contract ISignUpGatekeeper",
        name: "_signUpGatekeeper",
        type: "address",
      },
      {
        internalType: "contract IInitialVoiceCreditProxy",
        name: "_voiceCreditProxy",
        type: "address",
      },
      {
        internalType: "contract AccQueue",
        name: "_stateAq",
        type: "address",
      },
      {
        internalType: "contract AccQueue",
        name: "_messageAq",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialised",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mergeMessageAq",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_numSrQueueOps",
        type: "uint256",
      },
    ],
    name: "mergeMessageAqSubRoots",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mergeStateAq",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_numSrQueueOps",
        type: "uint256",
      },
    ],
    name: "mergeStateAqSubRoots",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "messageAq",
    outputs: [
      {
        internalType: "contract AccQueue",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "messageTreeDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "messageTreeSubDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "numBatchesProcessed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "numMessages",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "numPolls",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "numSignUps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "openSignUpPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pollResults",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "polls",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newStateCommitment",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_newSbCommitment",
        type: "uint256",
      },
      {
        internalType: "uint256[8]",
        name: "_proof",
        type: "uint256[8]",
      },
    ],
    name: "processMessages",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "msgType",
            type: "uint256",
          },
          {
            internalType: "uint256[10]",
            name: "data",
            type: "uint256[10]",
          },
        ],
        internalType: "struct Jubjub.Message",
        name: "_message",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey",
        name: "_encPubKey",
        type: "tuple",
      },
    ],
    name: "publishMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "msgType",
            type: "uint256",
          },
          {
            internalType: "uint256[10]",
            name: "data",
            type: "uint256[10]",
          },
        ],
        internalType: "struct Jubjub.Message[]",
        name: "_messages",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey[]",
        name: "_encPubKeys",
        type: "tuple[]",
      },
    ],
    name: "publishMessageBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract VkRegistry",
        name: "_vkRegistry",
        type: "address",
      },
    ],
    name: "setVkRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey",
        name: "_pubKey",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_signUpGatekeeperData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "_initialVoiceCreditProxyData",
        type: "bytes",
      },
    ],
    name: "signUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "signUpGatekeeper",
    outputs: [
      {
        internalType: "contract ISignUpGatekeeper",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "signUpTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "signUpsOpen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_voteOptionTreeDepth",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_duration",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey",
        name: "_coordinatorPubKey",
        type: "tuple",
      },
    ],
    name: "startVoting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stateAq",
    outputs: [
      {
        internalType: "contract AccQueue",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stateLeafTimeStamps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stateTreeDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stateTreeSubDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vkRegistry",
    outputs: [
      {
        internalType: "contract VkRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "voiceCreditProxy",
    outputs: [
      {
        internalType: "contract IInitialVoiceCreditProxy",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "voteDeadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "voteDurationSeconds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "voteOptionTreeDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "0x60806040523480156200001157600080fd5b506200001c62000139565b7f0ef71f46e11a513c599eed9dd03576c33439bcfb1cee155316f90541e41649ba14620000a15760405162461bcd60e51b815260206004820152602860248201527f4d4143493a20424c414e4b5f53544154455f4c4541465f4841534820697320696044820152671b98dbdc9c9958dd60c21b60648201526084015b60405180910390fd5b620000ab62000199565b7f1dee9f497aa52e2ad4b049b789afb5056fbee5a0e3f1083a92d93cb3a5a70fb4146200012e5760405162461bcd60e51b815260206004820152602a60248201527f4d4143493a20424c414e4b5f4d4553534147455f4c4541465f48415348206973604482015269081a5b98dbdc9c9958dd60b21b606482015260840162000098565b6000608755620005ea565b604080518082018252600080516020620043d58339815191528152600080516020620043f5833981519152602080830191909152825160608101845282815260009181018290529283018190529162000192816200025f565b9250505090565b60408051610140810182527f12817f4161f2f5ded33f26c55735a77e80e4f8975483c8c2704745128417f711815260006020808301829052828401829052606083018290526080830182905260a0830182905260c0830182905260e083018290526101008301829052610120830182905283518085018552600080516020620043d58339815191528152600080516020620043f583398151915281830152845180860190955260018552908401839052909262000257818362000314565b935050505090565b60006200026b62000537565b82515181528251602090810151818301528301518160026020020152604083810151606083015251631efdc45960e11b815273__$56e03346d0918fb20a2db08690fd2c2075$__90633dfb88b290620002c990849060040162000573565b602060405180830381865af4158015620002e7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906200030d9190620005a6565b9392505050565b60006200032062000555565b6020848101805151835280518201519183019190915280516040908101519083015280516060908101519083015251608090810151908201526200036362000555565b6020858101805160a0908101518452815160c0015184840152815160e0015160408086019190915282516101000151606086015291516101200151608085015281519081018252875181529051639cfced9760e01b815273__$e63b1c9f9b66f613a0dd27ec595fdb417f$__92639cfced9792919082019084908490620003ef908990600401620005c0565b602060405180830381865af41580156200040d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620004339190620005a6565b815260200173__$e63b1c9f9b66f613a0dd27ec595fdb417f$__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__$8f0718d15a58b4353249f9bf6422c5f00e$__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__$e63b1c9f9b66f613a0dd27ec595fdb417f$__92639cfced979291908201908490849061148d90899060040161395a565b602060405180830381865af41580156114aa573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114ce919061367b565b815260200173__$e63b1c9f9b66f613a0dd27ec595fdb417f$__639cfced97866040518263ffffffff1660e01b815260040161150a919061395a565b602060405180830381865af4158015611527573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061154b919061367b565b81526020018760000151815260200187602001518152506040518263ffffffff1660e01b815260040161157e919061395a565b602060405180830381865af415801561159b573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115bf919061367b565b925050505b92915050565b6115d2612d98565b60865460ff16156116225760405162461bcd60e51b815260206004820152601a60248201527922a92927a92fa9a4a3a72aa829afa0a62922a0a22cafa7a822a760311b60448201526064016108d2565b6086805460ff19166001179055565b611639612d98565b6116436000612df7565b565b8260005b818160ff1610156116c0576116ae86868360ff1681811061166c5761166c6136f8565b905061016002018036038101906116839190613982565b85858460ff16818110611698576116986136f8565b90506040020180360381019061040e919061399f565b806116b8816139bb565b915050611649565b505050505050565b600080604051806101400160405280600080516020613d26833981519152815260200160008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000815250905060006040518060400160405280600080516020613d068339815191528152602001600080516020613d668339815191528152509050600060405180604001604052806001815260200184815250905061178381836113b8565b935050505090565b6000611795612ec1565b82515181528251602090810151818301528301518160026020020152604083810151606083015251631efdc45960e11b815273__$56e03346d0918fb20a2db08690fd2c2075$__90633dfb88b2906117f19084906004016139db565b602060405180830381865af415801561180e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611832919061367b565b9392505050565b600054610100900460ff16158080156118595750600054600160ff909116105b806118735750303b158015611873575060005460ff166001145b6118d65760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b60648201526084016108d2565b6000805460ff1916600117905580156118f9576000805461ff0019166101001790555b611901612e49565b600061190b611fe9565b6001600160a01b0316141561195d5760405162461bcd60e51b8152602060048201526018602482015277129d589a9d58881bdddb995c881b5d5cdd081899481cd95d60421b60448201526064016108d2565b606f5460ff16156119ac5760405162461bcd60e51b8152602060048201526019602482015278135050d24e88185b1c9958591e481a5b9a5d1a585b1a5cd959603a1b60448201526064016108d2565b426083556086805460ff199081166001908117909255606f80549091169091179055607e80546001600160a01b038088166001600160a01b031992831617909255607f8054878416908316179055607c80548684169083168117909155607d80549386169390921692909217905560658b9055606689905560678a9055606888905560408051636ed44d3760e11b815290516000929163dda89a6e9160048281019260209291908290030181865afa158015611a6c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a90919061367b565b1415611b2657607c54604051631ffc735d60e01b81527f0ef71f46e11a513c599eed9dd03576c33439bcfb1cee155316f90541e41649ba60048201526001600160a01b0390911690631ffc735d906024016020604051808303816000875af1158015611b00573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611b24919061367b565b505b607d60009054906101000a90046001600160a01b03166001600160a01b031663dda89a6e6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611b79573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611b9d919061367b565b15611bea5760405162461bcd60e51b815260206004820152601d60248201527f4d4143493a206d657373616765206171206973206e6f7420656d70747900000060448201526064016108d2565b607d54604051631ffc735d60e01b81527f1dee9f497aa52e2ad4b049b789afb5056fbee5a0e3f1083a92d93cb3a5a70fb460048201526001600160a01b0390911690631ffc735d906024016020604051808303816000875af1158015611c54573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611c78919061367b565b5085600081518110611c8c57611c8c6136f8565b6020026020010151606a600060058110611ca857611ca86136f8565b0155855186906001908110611cbf57611cbf6136f8565b6020026020010151606a600160058110611cdb57611cdb6136f8565b0155855186906002908110611cf257611cf26136f8565b6020026020010151606a600260058110611d0e57611d0e6136f8565b0155855186906003908110611d2557611d256136f8565b6020026020010151606a600360058110611d4157611d416136f8565b0155855186906004908110611d5857611d586136f8565b6020026020010151606a600460058110611d7457611d746136f8565b0155607c546040805163442c38c760e11b815290516001600160a01b0390921691638858718e916004808201926020929091908290030181865afa158015611dc0573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611de4919061367b565b60665414611e045760405162461bcd60e51b81526004016108d290613a03565b607d60009054906101000a90046001600160a01b03166001600160a01b0316638858718e6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611e57573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611e7b919061367b565b60685414611e9b5760405162461bcd60e51b81526004016108d290613a03565b607c60009054906101000a90046001600160a01b03166001600160a01b031663a27154ba6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611eee573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611f12919061367b565b60655410611f545760405162461bcd60e51b815260206004820152600f60248201526e0929c869ea4a48a86a840888aa0a89608b1b60448201526064016108d2565b604080516001600160a01b038088168252861660208201527f45acd56f401dc3db1d520e5e214f090b4ab3e3fbf42fd24596cb511edaad876a910160405180910390a18015611fdd576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b50505050505050505050565b6033546001600160a01b031690565b612000612d98565b607d60009054906101000a90046001600160a01b03166001600160a01b03166369e7c5866040518163ffffffff1660e01b8152600401602060405180830381865afa158015612053573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906120779190613622565b158015612087575060865460ff16155b6120a35760405162461bcd60e51b81526004016108d290613644565b607d60009054906101000a90046001600160a01b03166001600160a01b031663b6a64acd6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156120f6573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061211a9190613622565b61217d57607d5460405163c15da65b60e01b8152600481018390526001600160a01b039091169063c15da65b90602401600060405180830381600087803b15801561216457600080fd5b505af1158015612178573d6000803e3d6000fd5b505050505b6040518181527f1245b881cb30fdad22b2f9fde2d5c2a3605bbdf272d5e8a2235d8c9e81aba2ce906020015b60405180910390a150565b60006121be612edf565b838152602081018390526040516362a361bb60e01b815273__$c6850fb4e0ee9ead61bcd830cbea02ad6d$__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__$c6850fb4e0ee9ead61bcd830cbea02ad6d$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";

type JubjubConstructorParams =
  | [linkLibraryAddresses: JubjubLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: JubjubConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class Jubjub__factory extends ContractFactory {
  constructor(...args: JubjubConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, Jubjub__factory.linkBytecode(linkLibraryAddresses), signer);
    }
  }

  static linkBytecode(linkLibraryAddresses: JubjubLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$56e03346d0918fb20a2db08690fd2c2075\\$__", "g"),
      linkLibraryAddresses["contracts/poseidon/PoseidonT5.sol:PoseidonT5"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$e63b1c9f9b66f613a0dd27ec595fdb417f\\$__", "g"),
      linkLibraryAddresses["contracts/poseidon/PoseidonT6.sol:PoseidonT6"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$8f0718d15a58b4353249f9bf6422c5f00e\\$__", "g"),
      linkLibraryAddresses["contracts/poseidon/PoseidonT4.sol:PoseidonT4"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$c6850fb4e0ee9ead61bcd830cbea02ad6d\\$__", "g"),
      linkLibraryAddresses["contracts/poseidon/PoseidonT3.sol:PoseidonT3"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Jubjub> {
    return super.deploy(overrides || {}) as Promise<Jubjub>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Jubjub {
    return super.attach(address) as Jubjub;
  }
  override connect(signer: Signer): Jubjub__factory {
    return super.connect(signer) as Jubjub__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): JubjubInterface {
    return new utils.Interface(_abi) as JubjubInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Jubjub {
    return new Contract(address, _abi, signerOrProvider) as Jubjub;
  }
}

export interface JubjubLibraryAddresses {
  ["contracts/poseidon/PoseidonT5.sol:PoseidonT5"]: string;
  ["contracts/poseidon/PoseidonT6.sol:PoseidonT6"]: string;
  ["contracts/poseidon/PoseidonT4.sol:PoseidonT4"]: string;
  ["contracts/poseidon/PoseidonT3.sol:PoseidonT3"]: string;
}
